import React, { useEffect, useState } from 'react';
import { DialogComponent, Tables } from '../../../../../../../../Components';
import { RiskRatingConfigEnum } from '../../../../../../../../Enums';
import './RiskReasons.scss';
import { groupBy } from 'lodash';

export default function RiskReasonsDialog({
  isOpen,
  riskRatingDetails,
  close,
  parentTranslationPath,
}) {
  const [groupedData, setGroupedData] = useState([]);
  const formatGroupedData = () => {
    const _groupedData = [];

    if (riskRatingDetails) {
      const filteredData = riskRatingDetails.filter((item) => {
        if (item.riskRating === 3) return false;
        if (item.riskRatingFormLabelName === 'CustomerType') {
          return (
            item.fieldName === 'PEP/Associated PEP' && item.riskRating === 1
          );
        }
        return true;
      });

      const grouped = groupBy(filteredData, 'riskRatingFormLabelName');

      let currentIndex = 0;
      let groupLength = 1;

      while (currentIndex < groupLength) {
        let item = {};
        Object.entries(grouped).forEach(([key, value]) => {
          item[key] = value?.[currentIndex];
          if (value.some((v) => v.reasons === 'UAE Residence Address')) {
            item.uaeResidence = {
              reasons: 'UAE Residence Address',
              riskRating: 1,
            };
          }
          if (value?.length > groupLength) {
            groupLength = value.length;
          }
        });
        currentIndex++;

        _groupedData.push(item);
      }
    }

    setGroupedData(_groupedData);
  };

  const getRatingStyleClass = (ratingName) =>
    Object.values(RiskRatingConfigEnum).find(
      (item) => item.value === ratingName
    )?.class || '';

  useEffect(() => {
    formatGroupedData();
  }, []);

  return (
    <>
      <DialogComponent
        titleText={'risk-reasons'}
        isOpen={isOpen}
        onCancelClicked={close}
        onCloseClicked={close}
        hideSaveBtn
        parentTranslationPath={parentTranslationPath}
        dialogContent={
          <Tables
            data={groupedData}
            parentTranslationPath={parentTranslationPath}
            defaultActions={[]}
            headerData={[
              {
                id: 1,
                label: 'customerType',
                component: (item) => (
                  <div className='d-flex fa-center gap-12'>
                    <span
                      className={`RateDot ${getRatingStyleClass(
                        item.CustomerType?.riskRating
                      )}`}
                    ></span>
                    <span className='fw-simi-bold'>
                      {item.CustomerType?.reasons || '-'}
                    </span>
                  </div>
                ),
              },
              {
                id: 2,
                label: 'residenceAddress',
                component: (item) => (
                  <div className='d-flex fa-center gap-12'>
                    <span
                      className={`RateDot ${getRatingStyleClass(
                        item.ResidenceStatus?.riskRating
                      )}`}
                    ></span>
                    <span className='fw-simi-bold'>
                      {item.ResidenceStatus?.reasons || '-'}
                    </span>
                  </div>
                ),
              },
              {
                id: 3,
                label: 'customerSourceOfFunds',
                component: (item) => (
                  <div className='d-flex fa-center gap-12'>
                    <span
                      className={`RateDot ${getRatingStyleClass(
                        item['CustomerSourceOfFund/Wealth']?.riskRating
                      )}`}
                    ></span>
                    <span className='fw-simi-bold'>
                      {item['CustomerSourceOfFund/Wealth']?.reasons || '-'}
                    </span>
                  </div>
                ),
              },
              {
                id: 4,
                label: 'natureOfTransactions',
                input: 'natureOfTransactions',
                component: (item) => (
                  <div className='d-flex fa-center gap-12'>
                    <span
                      className={`RateDot ${getRatingStyleClass(
                        item['NatureOfTransaction(PaymentMethod)']?.riskRating
                      )}`}
                    ></span>
                    <span className='fw-simi-bold'>
                      {item['NatureOfTransaction(PaymentMethod)']?.reasons ||
                        '-'}
                    </span>
                  </div>
                ),
              },
              {
                id: 5,
                label: 'jurisdictionRisk',
                input: 'jurisdictionRisk',
                component: (item) => {
                  const jurisdiction = item['JurisdictionRisk(Nationality)'];
                  if (jurisdiction?.reasons === 'UAE Residence Address')
                    return null;
                  return (
                    <div className='d-flex fa-center gap-12'>
                      <span
                        className={`RateDot ${getRatingStyleClass(
                          jurisdiction?.riskRating
                        )}`}
                      ></span>
                      <span className='fw-simi-bold'>
                        {jurisdiction?.reasons || '-'}
                      </span>
                    </div>
                  );
                },
              },
              {
                id: 6,
                label: ' UAE Residence',
                component: (item) => (
                  <div className='d-flex fa-center gap-12'>
                    <span
                      className={`RateDot ${getRatingStyleClass(
                        item.uaeResidence?.riskRating
                      )}`}
                    ></span>
                    <span className='fw-simi-bold'>
                      {item?.uaeResidence?.reasons || '-'}
                    </span>
                  </div>
                ),
              },
            ]}
          />
        }
      />
    </>
  );
}
